const respondentSteps = [
  'Shared Questionnaire',
  'Review & E-sign',
  'Final Documents'
]

module.exports = respondentSteps